import React from "react";
import { Box } from "@material-ui/core";
import { FTLTextField, FTLPhoneField, FTLTypography, FTLSelectAsync, } from "ftl-dashboards-ui-kit";
import { handleError } from "ftl-dashboards-core";
export const ContactDataTab = ({ formik, numberFormat, setNumberFormat, getCountries, }) => {
    var _a, _b;
    return (React.createElement(Box, { mt: 6 },
        React.createElement(Box, null,
            React.createElement(FTLTypography, { variant: "h3" }, "\u041F\u043E\u0447\u0442\u0430"),
            React.createElement(Box, { mt: 2 },
                React.createElement(FTLTypography, { variant: "p2" },
                    "\u0412\u0430\u0448 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0430\u0434\u0440\u0435\u0441 \u043F\u043E\u0447\u0442\u044B",
                    " ",
                    React.createElement("span", { style: { fontWeight: "bold" } }, formik.values.email)))),
        React.createElement(Box, { mt: 10 },
            React.createElement(FTLTypography, { variant: "h3" }, "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"),
            React.createElement(Box, { mt: 2, maxWidth: "360px" },
                React.createElement(FTLPhoneField, { code: (_a = numberFormat === null || numberFormat === void 0 ? void 0 : numberFormat.code) !== null && _a !== void 0 ? _a : "", name: "phoneNumber", format: (_b = numberFormat === null || numberFormat === void 0 ? void 0 : numberFormat.mask) !== null && _b !== void 0 ? _b : "", phoneCodeComponent: React.createElement(Box, { maxWidth: 80 },
                        React.createElement(FTLSelectAsync, { placeholder: "\u041A\u043E\u0434", menuWidth: 256, showLoader: false, onChange: (option) => {
                                var _a, _b;
                                formik.setValues(Object.assign(Object.assign({}, formik.values), { countryId: (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : "", phoneNumber: "" }), false);
                                setNumberFormat((_b = option === null || option === void 0 ? void 0 : option.phoneNumberFormat) !== null && _b !== void 0 ? _b : null);
                            }, isError: formik.errors.phoneNumber && formik.submitCount > 0
                                ? true
                                : false, value: numberFormat && numberFormat.code
                                ? {
                                    value: numberFormat.code,
                                    label: numberFormat.code,
                                }
                                : null, loadData: {
                                promiseFn: (args) => getCountries(Object.assign({}, args)).catch((error) => {
                                    handleError({
                                        error,
                                        defaultError: "Произошла ошибка при попытке загрузить данные стран",
                                    });
                                    return error;
                                }),
                                normalizeScheme: {
                                    value: "id",
                                    label: (item) => item.phoneNumberFormat.code,
                                    meta: "name",
                                    phoneNumberFormat: "phoneNumberFormat",
                                },
                            } })), mask: "_", error: formik.errors.phoneNumber && formik.submitCount > 0 ? true : false, value: formik.values.phoneNumber, customInput: FTLTextField, onChange: (e) => {
                        formik.setFieldValue("phoneNumber", e.target.value, false);
                    }, placeholder: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430", fullWidth: true })))));
};
export default ContactDataTab;
//# sourceMappingURL=ContactDataTab.js.map